import { IdentityEventParams } from "@identity/services";

export enum DataWarehouseEventType {
  identity,
}

export interface TimeBasedParams {
  cb: number;
  url: string;
}

export interface TrackingParams {
  a?: number;
  action?: string;
  ad_height?: number;
  ad_width?: number;
  beacon?: string;
  browser_ts?: number;
  c?: number | string;
  ck?: string;
  category?: string;
  country?: string;
  creative_id?: number | string;
  eventName?: string;
  event_name?: string;
  ga_action?: string;
  ga_category?: string;
  ga_label?: string;
  ga_value?: any;
  keyvals?: string;
  label?: string;
  lc?: string;
  line_item_id?: number | string;
  load_time?: number;
  n?: number;
  partner_name?: string;
  partner_identity_id?: string;
  position?: string;
  prop_name?: string;
  prop_value?: string;
  pv_number?: number;
  pv_number_global?: number;
  pv_unique_id?: string;
  r?: string;
  rv?: number;
  s?: string;
  session_id?: string;
  slot_id?: string;
  slot_size?: string;
  t?: string;
  timestamp?: number;
  tz_offset?: number;
  u?: number;
  ua?: string;
  value?: any;
  x?: string;
}

export type EventParams = IdentityEventParams;

export type DataWarehouseParams = EventParams &
  TimeBasedParams &
  TrackingParams;
